import React from "react"
import Link from "gatsby-link"
import AboutComponent from "../components/About"
import coolbg from "../images/cool-background.png"
import Card from "../components/Card"
import Layout from "../components/layout"

const NewPage = () => (
  <Layout>
    <div>
      <meta name="title" content="What's New - The Views News" />
      <meta
        name="description"
        content="Here's what's new with Version 3.0 of The Views News"
      />

      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://viewsnews.co/whats-new" />
      <meta property="og:title" content="What's New - The Views News" />
      <meta
        property="og:description"
        content="Here's what's new with Version 3.0 of The Views News"
      />
      <meta
        property="og:image"
        content="https://i.postimg.cc/6qs9mJ4r/Top-Shelf-Copy.jpg"
      />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://viewsnews.co/whats-new" />
      <meta property="twitter:title" content="What's New - The Views News" />
      <meta
        property="twitter:description"
        content="Here's what's new with Version 3.0 of The Views News"
      />
      <meta
        property="twitter:image"
        content="https://i.postimg.cc/6qs9mJ4r/Top-Shelf-Copy.jpg"
      />
      <AboutComponent
        image="https://images.unsplash.com/photo-1539889500977-bc134ff525b9?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c5a8150c4cf7ab069e30cbf14489357a&q=100"
        title="Version 3.0"
        text="Welcome to Version 3 of Views. With a bunch of new features, Views is more capable to become your #1 news app."
      />
      <div className="WhatsNew">
        <img src="https://i.postimg.cc/k51bjPWt/Website-1.png" />
        <div className="WhatsNewDescription">
          <h2>NEW</h2>
          <h1>Views Community</h1>
          <p>
            With the brand new Views Community, write stories and share your{" "}
            <b>views</b> with the rest of the world. Don't hesitate to take a
            stand as the Community is heavily monitored and only comments which
            push the debate in a healthy manner will be allowed. Memes, trolls,
            and bots are heavily restricted.
          </p>
        </div>
        <hr />
        <img src="https://i.postimg.cc/ncBSsxSD/Website-2.png" />
        <div className="WhatsNewDescription">
          <h2>NEW</h2>
          <h1>Siri Shortcuts</h1>
          <p>
            Want to read your bookmarks, publish a new story, or change the
            theme of the app? Just ask Siri! Now customizable with the{" "}
            <a href="http://geo.itunes.apple.com/us/app/workflow/id915249334?mt=8">
              Shortcuts
            </a>{" "}
            app and available on iPhone, iPad, Apple Watch, and HomePod!
          </p>
        </div>
        <hr />
        <img src="https://i.postimg.cc/3xLQcyKb/Website-3.png" />
        <div className="WhatsNewDescription">
          <h3>REDESIGNED</h3>
          <h1>Felicity</h1>
          <p>
            Higher. Further. Faster. With Version 3, Felicity is more capable
            than ever to become the ultimate news companion. You can have her
            search for hundreds of articles, summarize whole news articles into
            quick gist sentences, or strike up a friendly conversation with our
            loveable AI.
          </p>
        </div>
        <hr />
        <img src="https://i.postimg.cc/3JsXJ8kg/Website-4.png" />
        <div className="WhatsNewDescription">
          <h3>REDESIGNED</h3>
          <h1>Apple Watch</h1>
          <p>
            The all-new Apple Watch design takes advantage of Apple's latest
            Series 4. Scroll through cards detailing the latest news based on
            your choice of category, tap on one and read more! If it sounds
            interesting, you can continue reading it on your iPhone with the
            help of Handoff.
          </p>
        </div>
      </div>
      <div className="Beta">
        <h3>
          Make sure you have the latest version of Views.{" "}
          <a href="https://geo.itunes.apple.com/us/app/the-views-news/id1322754821?mt=8">
            Update now
          </a>{" "}
          to take advantage of all the fun, new features.
        </h3>
      </div>
    </div>
  </Layout>
)

export default NewPage
